import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../types";

const getQuickPayMasterProduct  = function(state:RootState) {
    return state?.quickPayMasterProduct;
  };

export const getQuickPayMasterProductList = createSelector(getQuickPayMasterProduct,(quickPayMasterProduct)=> quickPayMasterProduct)
